// Pattern: docs/design-patterns/frontend-form-handling
// Factory that builds a Zod password schema from the centralized policy config

import { z } from 'zod';

import type { PasswordPolicy } from './password-policy';
import { passwordPolicy } from './password-policy';

export function createPasswordSchema(policy: PasswordPolicy = passwordPolicy): z.ZodString {
  let schema = z
    .string()
    .min(policy.minLength, `Password must be at least ${policy.minLength} characters`);

  if (policy.requireUppercase) {
    schema = schema.regex(/[A-Z]/, 'Password must contain at least one uppercase letter');
  }
  if (policy.requireLowercase) {
    schema = schema.regex(/[a-z]/, 'Password must contain at least one lowercase letter');
  }
  if (policy.requireNumber) {
    schema = schema.regex(/\d/, 'Password must contain at least one number');
  }
  if (policy.requireSymbol) {
    schema = schema.regex(/[^A-Za-z0-9]/, 'Password must contain at least one special character');
  }

  return schema;
}
